import { render, staticRenderFns } from "./AddNewUnitModal.vue?vue&type=template&id=517be3e6&scoped=true"
import script from "./AddNewUnitModal.vue?vue&type=script&lang=js"
export * from "./AddNewUnitModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517be3e6",
  null
  
)

export default component.exports